// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/token.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ListRequestSchema } from "./common_pb.js";
import { file_agentplatform_httpv2_common } from "./common_pb.js";
import type { AgentToken, TokenStatus, TokenType } from "../v2/token_pb.js";
import { file_agentplatform_v2_token } from "../v2/token_pb.js";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import { file_google_api_annotations } from "../../google/api/annotations_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/token.proto.
 */
export const file_agentplatform_httpv2_token: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_httpv2_common, file_agentplatform_v2_token, file_buf_validate_validate, file_gnostic_openapi_v3_annotations, file_google_api_annotations]);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateAgentTokenRequest
 */
export type CreateAgentTokenRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateAgentTokenRequest"> & {
  /**
   * Token 名称，用户可读
   * @gotags: json:"name"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Token 类型（必填，不能是 UNSPECIFIED）
   * @gotags: json:"type"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.TokenType type = 2;
   */
  type: TokenType;

  /**
   * 绑定的 Agent 实例 ID（格式 ai-<...>）。
   * 仅 type=API 必填；type=WEBSOCKET 时可留空（连接级 token，运行时由 channel 路由到 agent）。
   * 字段级 pattern 仅在非空时校验；"非空"约束由消息级 CEL 在 API 分支强制。
   * @gotags: json:"agent_instance_id,omitempty"
   *
   * @generated from field: string agent_instance_id = 3 [json_name = "agent_instance_id"];
   */
  agentInstanceId: string;

  /**
   * 绑定的 WebSocket 渠道 ID（仅 type=WEBSOCKET 必填，其他类型留空）
   * 跨字段约束「WEBSOCKET 必填」由消息级 CEL 强制
   * @gotags: json:"channel_account_id,omitempty"
   *
   * @generated from field: string channel_account_id = 4 [json_name = "channel_account_id"];
   */
  channelAccountId: string;

  /**
   * 有效期截止时间（unix nano，0 = 永久有效）
   * @gotags: json:"expire_at,omitempty"
   *
   * @generated from field: int64 expire_at = 5 [json_name = "expire_at"];
   */
  expireAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateAgentTokenRequest.
 * Use `create(CreateAgentTokenRequestSchema)` to create a new message.
 */
export const CreateAgentTokenRequestSchema: GenMessage<CreateAgentTokenRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 0);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateAgentTokenResponse
 */
export type CreateAgentTokenResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateAgentTokenResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.CreateAgentTokenData data = 4;
   */
  data?: CreateAgentTokenData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateAgentTokenResponse.
 * Use `create(CreateAgentTokenResponseSchema)` to create a new message.
 */
export const CreateAgentTokenResponseSchema: GenMessage<CreateAgentTokenResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 1);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateAgentTokenData
 */
export type CreateAgentTokenData = Message<"infinigence.infini.agentplatform.httpv2.CreateAgentTokenData"> & {
  /**
   * 新创建的 token 记录 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Token 名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 明文 token 值（仅此一次返回，平台不再保留）
   * @gotags: json:"token"
   *
   * @generated from field: string token = 3;
   */
  token: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateAgentTokenData.
 * Use `create(CreateAgentTokenDataSchema)` to create a new message.
 */
export const CreateAgentTokenDataSchema: GenMessage<CreateAgentTokenData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 2);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetAgentTokenRequest
 */
export type GetAgentTokenRequest = Message<"infinigence.infini.agentplatform.httpv2.GetAgentTokenRequest"> & {
  /**
   * 记录 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetAgentTokenRequest.
 * Use `create(GetAgentTokenRequestSchema)` to create a new message.
 */
export const GetAgentTokenRequestSchema: GenMessage<GetAgentTokenRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 3);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetAgentTokenResponse
 */
export type GetAgentTokenResponse = Message<"infinigence.infini.agentplatform.httpv2.GetAgentTokenResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.AgentToken data = 4;
   */
  data?: AgentToken | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetAgentTokenResponse.
 * Use `create(GetAgentTokenResponseSchema)` to create a new message.
 */
export const GetAgentTokenResponseSchema: GenMessage<GetAgentTokenResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 4);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateAgentTokenRequest
 */
export type UpdateAgentTokenRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateAgentTokenRequest"> & {
  /**
   * 记录 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 新名称（不修改时留空）
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 新有效期截止时间（unix nano，0 = 永久有效；不修改时留空 / 传 -1）
   * @gotags: json:"expire_at,omitempty"
   *
   * @generated from field: int64 expire_at = 3 [json_name = "expire_at"];
   */
  expireAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateAgentTokenRequest.
 * Use `create(UpdateAgentTokenRequestSchema)` to create a new message.
 */
export const UpdateAgentTokenRequestSchema: GenMessage<UpdateAgentTokenRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 5);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateAgentTokenResponse
 */
export type UpdateAgentTokenResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateAgentTokenResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.AgentToken data = 4;
   */
  data?: AgentToken | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateAgentTokenResponse.
 * Use `create(UpdateAgentTokenResponseSchema)` to create a new message.
 */
export const UpdateAgentTokenResponseSchema: GenMessage<UpdateAgentTokenResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 6);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteAgentTokenRequest
 */
export type DeleteAgentTokenRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteAgentTokenRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteAgentTokenRequest.
 * Use `create(DeleteAgentTokenRequestSchema)` to create a new message.
 */
export const DeleteAgentTokenRequestSchema: GenMessage<DeleteAgentTokenRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 7);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteAgentTokenResponse
 */
export type DeleteAgentTokenResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteAgentTokenResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteAgentTokenResponse.
 * Use `create(DeleteAgentTokenResponseSchema)` to create a new message.
 */
export const DeleteAgentTokenResponseSchema: GenMessage<DeleteAgentTokenResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 8);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListAgentTokensResponse
 */
export type ListAgentTokensResponse = Message<"infinigence.infini.agentplatform.httpv2.ListAgentTokensResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListAgentTokensData data = 4;
   */
  data?: ListAgentTokensData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListAgentTokensResponse.
 * Use `create(ListAgentTokensResponseSchema)` to create a new message.
 */
export const ListAgentTokensResponseSchema: GenMessage<ListAgentTokensResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 9);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListAgentTokensData
 */
export type ListAgentTokensData = Message<"infinigence.infini.agentplatform.httpv2.ListAgentTokensData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v2.AgentToken items = 1;
   */
  items: AgentToken[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListAgentTokensData.
 * Use `create(ListAgentTokensDataSchema)` to create a new message.
 */
export const ListAgentTokensDataSchema: GenMessage<ListAgentTokensData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 10);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.RegenerateAgentTokenRequest
 */
export type RegenerateAgentTokenRequest = Message<"infinigence.infini.agentplatform.httpv2.RegenerateAgentTokenRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.RegenerateAgentTokenRequest.
 * Use `create(RegenerateAgentTokenRequestSchema)` to create a new message.
 */
export const RegenerateAgentTokenRequestSchema: GenMessage<RegenerateAgentTokenRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 11);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.RegenerateAgentTokenResponse
 */
export type RegenerateAgentTokenResponse = Message<"infinigence.infini.agentplatform.httpv2.RegenerateAgentTokenResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.RegenerateAgentTokenData data = 4;
   */
  data?: RegenerateAgentTokenData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.RegenerateAgentTokenResponse.
 * Use `create(RegenerateAgentTokenResponseSchema)` to create a new message.
 */
export const RegenerateAgentTokenResponseSchema: GenMessage<RegenerateAgentTokenResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 12);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.RegenerateAgentTokenData
 */
export type RegenerateAgentTokenData = Message<"infinigence.infini.agentplatform.httpv2.RegenerateAgentTokenData"> & {
  /**
   * 记录 ID（不变）
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Token 名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 重新生成的明文 token 值（仅此一次返回）
   * @gotags: json:"token"
   *
   * @generated from field: string token = 3;
   */
  token: string;

  /**
   * 重新生成时间（unix nano）
   * @gotags: json:"regenerated_at"
   *
   * @generated from field: int64 regenerated_at = 4 [json_name = "regenerated_at"];
   */
  regeneratedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.RegenerateAgentTokenData.
 * Use `create(RegenerateAgentTokenDataSchema)` to create a new message.
 */
export const RegenerateAgentTokenDataSchema: GenMessage<RegenerateAgentTokenData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 13);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.EnableAgentTokenRequest
 */
export type EnableAgentTokenRequest = Message<"infinigence.infini.agentplatform.httpv2.EnableAgentTokenRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.EnableAgentTokenRequest.
 * Use `create(EnableAgentTokenRequestSchema)` to create a new message.
 */
export const EnableAgentTokenRequestSchema: GenMessage<EnableAgentTokenRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 14);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.EnableAgentTokenResponse
 */
export type EnableAgentTokenResponse = Message<"infinigence.infini.agentplatform.httpv2.EnableAgentTokenResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.EnableAgentTokenData data = 4;
   */
  data?: EnableAgentTokenData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.EnableAgentTokenResponse.
 * Use `create(EnableAgentTokenResponseSchema)` to create a new message.
 */
export const EnableAgentTokenResponseSchema: GenMessage<EnableAgentTokenResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 15);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.EnableAgentTokenData
 */
export type EnableAgentTokenData = Message<"infinigence.infini.agentplatform.httpv2.EnableAgentTokenData"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 更新后的状态（应为 ENABLED）
   * @gotags: json:"status"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.TokenStatus status = 2;
   */
  status: TokenStatus;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.EnableAgentTokenData.
 * Use `create(EnableAgentTokenDataSchema)` to create a new message.
 */
export const EnableAgentTokenDataSchema: GenMessage<EnableAgentTokenData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 16);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DisableAgentTokenRequest
 */
export type DisableAgentTokenRequest = Message<"infinigence.infini.agentplatform.httpv2.DisableAgentTokenRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DisableAgentTokenRequest.
 * Use `create(DisableAgentTokenRequestSchema)` to create a new message.
 */
export const DisableAgentTokenRequestSchema: GenMessage<DisableAgentTokenRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 17);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DisableAgentTokenResponse
 */
export type DisableAgentTokenResponse = Message<"infinigence.infini.agentplatform.httpv2.DisableAgentTokenResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.DisableAgentTokenData data = 4;
   */
  data?: DisableAgentTokenData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DisableAgentTokenResponse.
 * Use `create(DisableAgentTokenResponseSchema)` to create a new message.
 */
export const DisableAgentTokenResponseSchema: GenMessage<DisableAgentTokenResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 18);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DisableAgentTokenData
 */
export type DisableAgentTokenData = Message<"infinigence.infini.agentplatform.httpv2.DisableAgentTokenData"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 更新后的状态（应为 DISABLED）
   * @gotags: json:"status"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.TokenStatus status = 2;
   */
  status: TokenStatus;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DisableAgentTokenData.
 * Use `create(DisableAgentTokenDataSchema)` to create a new message.
 */
export const DisableAgentTokenDataSchema: GenMessage<DisableAgentTokenData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 19);

/**
 * 创建前预检：token 名称在所属范围内是否唯一。按 type 决定范围：
 *   - API：同一 agent_instance_id 下唯一
 *   - WEBSOCKET：同一 channel_account_id 下唯一
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.CheckAgentTokenNameRequest
 */
export type CheckAgentTokenNameRequest = Message<"infinigence.infini.agentplatform.httpv2.CheckAgentTokenNameRequest"> & {
  /**
   * 待校验名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Token 类型（必填，不能是 UNSPECIFIED）
   * @gotags: json:"type"
   *
   * @generated from field: infinigence.infini.agentplatform.v2.TokenType type = 2;
   */
  type: TokenType;

  /**
   * 绑定的 Agent 实例 ID（格式 ai-<...>）。仅 type=API 必填。
   * @gotags: json:"agent_instance_id,omitempty"
   *
   * @generated from field: string agent_instance_id = 3 [json_name = "agent_instance_id"];
   */
  agentInstanceId: string;

  /**
   * 绑定的渠道账号 ID。仅 type=WEBSOCKET 必填。
   * @gotags: json:"channel_account_id,omitempty"
   *
   * @generated from field: string channel_account_id = 4 [json_name = "channel_account_id"];
   */
  channelAccountId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CheckAgentTokenNameRequest.
 * Use `create(CheckAgentTokenNameRequestSchema)` to create a new message.
 */
export const CheckAgentTokenNameRequestSchema: GenMessage<CheckAgentTokenNameRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 20);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CheckAgentTokenNameResponse
 */
export type CheckAgentTokenNameResponse = Message<"infinigence.infini.agentplatform.httpv2.CheckAgentTokenNameResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.CheckAgentTokenNameData data = 4;
   */
  data?: CheckAgentTokenNameData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CheckAgentTokenNameResponse.
 * Use `create(CheckAgentTokenNameResponseSchema)` to create a new message.
 */
export const CheckAgentTokenNameResponseSchema: GenMessage<CheckAgentTokenNameResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 21);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CheckAgentTokenNameData
 */
export type CheckAgentTokenNameData = Message<"infinigence.infini.agentplatform.httpv2.CheckAgentTokenNameData"> & {
  /**
   * 名称在范围内是否可用（true = 未占用）
   * @gotags: json:"available"
   *
   * @generated from field: bool available = 1;
   */
  available: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CheckAgentTokenNameData.
 * Use `create(CheckAgentTokenNameDataSchema)` to create a new message.
 */
export const CheckAgentTokenNameDataSchema: GenMessage<CheckAgentTokenNameData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_token, 22);

/**
 * AgentTokenHTTPV2Service 采用 RPC 风格路由：统一 POST，路径即 RPC 方法名。
 * 详细 schema 与字段约定见 docs/spec/rpc-spec.md。
 *
 * @generated from service infinigence.infini.agentplatform.httpv2.AgentTokenHTTPV2Service
 */
export const AgentTokenHTTPV2Service: GenService<{
  /**
   * 创建 token（响应返回明文，仅此一次）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentTokenHTTPV2Service.CreateAgentToken
   */
  createAgentToken: {
    methodKind: "unary";
    input: typeof CreateAgentTokenRequestSchema;
    output: typeof CreateAgentTokenResponseSchema;
  },
  /**
   * 获取单个 token（脱敏）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentTokenHTTPV2Service.GetAgentToken
   */
  getAgentToken: {
    methodKind: "unary";
    input: typeof GetAgentTokenRequestSchema;
    output: typeof GetAgentTokenResponseSchema;
  },
  /**
   * 更新 token 元数据（名称 / 有效期；状态变更走 Enable/Disable）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentTokenHTTPV2Service.UpdateAgentToken
   */
  updateAgentToken: {
    methodKind: "unary";
    input: typeof UpdateAgentTokenRequestSchema;
    output: typeof UpdateAgentTokenResponseSchema;
  },
  /**
   * 删除 token（幂等：已删除返回 200）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentTokenHTTPV2Service.DeleteAgentToken
   */
  deleteAgentToken: {
    methodKind: "unary";
    input: typeof DeleteAgentTokenRequestSchema;
    output: typeof DeleteAgentTokenResponseSchema;
  },
  /**
   * 列出 token（分页 / 过滤）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentTokenHTTPV2Service.ListAgentTokens
   */
  listAgentTokens: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListAgentTokensResponseSchema;
  },
  /**
   * 重新生成：旧 token 立即失效，响应返回新明文（仅此一次）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentTokenHTTPV2Service.RegenerateAgentToken
   */
  regenerateAgentToken: {
    methodKind: "unary";
    input: typeof RegenerateAgentTokenRequestSchema;
    output: typeof RegenerateAgentTokenResponseSchema;
  },
  /**
   * 启用
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentTokenHTTPV2Service.EnableAgentToken
   */
  enableAgentToken: {
    methodKind: "unary";
    input: typeof EnableAgentTokenRequestSchema;
    output: typeof EnableAgentTokenResponseSchema;
  },
  /**
   * 禁用
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentTokenHTTPV2Service.DisableAgentToken
   */
  disableAgentToken: {
    methodKind: "unary";
    input: typeof DisableAgentTokenRequestSchema;
    output: typeof DisableAgentTokenResponseSchema;
  },
  /**
   * 校验 token 名称在所属范围内是否唯一
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentTokenHTTPV2Service.CheckAgentTokenName
   */
  checkAgentTokenName: {
    methodKind: "unary";
    input: typeof CheckAgentTokenNameRequestSchema;
    output: typeof CheckAgentTokenNameResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agentplatform_httpv2_token, 0);

